import interFontUrl from "../assets/fonts/Inter-VariableFont_opsz,wght.ttf";
import robotoCondensedFontUrl from "../assets/fonts/RobotoCondensed-VariableFont_wght.ttf";

let fontsLoadScheduled = false;
let fontsLoadPromise: null | Promise<void> = null;

const resolveBundleAssetUrl = (assetPath: string) => {
  const currentScript = document.currentScript instanceof HTMLScriptElement ? document.currentScript : null;
  const appScript = currentScript
    ?? document.querySelector<HTMLScriptElement>('script[src$="/a/res/app.js"], script[src$="/v/res/app.js"]');
  const baseUrl = appScript?.src ?? window.location.href;
  return new URL(assetPath, baseUrl).toString();
};

const loadFont = async (fontFace: FontFace) => {
  const loadedFont = await fontFace.load();
  document.fonts.add(loadedFont);
};

const loadAppFonts = async () => {
  await Promise.allSettled([
    loadFont(new FontFace("Inter", `url(${resolveBundleAssetUrl(interFontUrl)})`, {
      display: "swap",
      style: "normal",
      weight: "100 900",
    })),
    loadFont(new FontFace("Roboto Condensed", `url(${resolveBundleAssetUrl(robotoCondensedFontUrl)})`, {
      display: "swap",
      style: "normal",
      weight: "100 900",
    })),
  ]);
};

export const ensureAppFontsLoaded = () => {
  if (typeof window === "undefined" || typeof document === "undefined" || !("fonts" in document)) {
    return Promise.resolve();
  }

  if (!fontsLoadPromise) {
    fontsLoadPromise = new Promise((resolve) => {
      requestAnimationFrame(() => {
        window.setTimeout(() => {
          void loadAppFonts().finally(resolve);
        }, 0);
      });
    });
  }

  return fontsLoadPromise;
};

export const scheduleAppFontsLoad = () => {
  if (fontsLoadScheduled) {
    return;
  }

  fontsLoadScheduled = true;
  void ensureAppFontsLoaded();
};
